import React, { useState, useEffect } from 'react';
import QuickMenu from '../../components/QuickMenu/QuickMenu';
import { FaDirections } from 'react-icons/fa';
import parksData from './parks.json';

const EmergencyPoints = () => {
  const [points, setPoints] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setPoints(parksData);
    setLoading(false);
  }, []);

  const handleGetDirections = (coordinates) => {
    const [lat, lng] = coordinates.split('/').map(coord => coord.trim());
    const url = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}&travelmode=driving`;
    window.open(url, '_blank');
  };

  if (loading) {
    return (
      <div className="emergency-points-page">
        <div className="container py-5">
          <div className="row">
            <QuickMenu />
            <div className="col-md-10">
              <div className="loading">Yükleniyor...</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="emergency-points-page">
   
      <div className="container py-5">
        <div className="row">
          <QuickMenu />
          
          <div className="col-md-10">
            <div className="emergency-points-content">
              <h1 className="page-title">Afet ve Acil Durum Toplanma Alanları</h1>
              
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Sıra No</th>
                      <th>Toplanma Alanı Adı</th>
                      <th>Mahalle</th>
                      <th>Kod</th>
                      <th>Yol Tarifi</th>
                    </tr>
                  </thead>
                  <tbody>
                    {points.map((point) => (
                      <tr key={point["SIRA NO"]}>
                        <td>{point["SIRA NO"]}</td>
                        <td>{point["PARK ADI"]}</td>
                        <td>{point["MAHALLE"]}</td>
                        <td>{point["KOD"]}</td>
                        <td>
                          <button
                            className="btn btn-directions"
                            onClick={() => handleGetDirections(point["ENLEM - BOYLAM X / Y"])}
                            title="Yol tarifi al"
                          >
                            <FaDirections /> Yol Tarifi
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="emergency-info">
                <h2>Önemli Bilgiler</h2>
                <ul>
                  <li>Toplanma alanlarını önceden öğrenin ve ailenizle paylaşın.</li>
                  <li>Acil durumlarda size en yakın toplanma alanına gitmeye çalışın.</li>
                  <li>Toplanma alanlarına giderken güvenli rotaları tercih edin.</li>
                  <li>Toplanma alanlarında yetkililerin yönlendirmelerini takip edin.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmergencyPoints;
